import { createClient } from '@supabase/supabase-js'
import { Database } from './types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl) {
  throw new Error("Missing VITE_SUPABASE_URL environment variable")
}

if (!supabaseAnonKey) {
  throw new Error("Missing VITE_SUPABASE_ANON_KEY environment variable")
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)
export const supabaseSignUp = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'supabase-signup',
    persistSession: false,
    autoRefreshToken: false,
  },
  global: {
    headers: {
      apikey: supabaseAnonKey,
      Authorization: `Bearer ${supabaseAnonKey}`,
    },
  },
})

export type Team = Database['public']['Tables']['teams']['Row']
export type UserTeam = Database['public']['Tables']['user_teams']['Row']
export type TOTPCode = Database['public']['Tables']['totp_codes']['Row']
export type Profile = Database['public']['Tables']['profiles']['Row']
export type TOTPCodeInsert = Database['public']['Tables']['totp_codes']['Insert']
export type UserTeamInsert = Database['public']['Tables']['user_teams']['Insert']
export type TOTPCategory = Database['public']['Tables']['totp_categories']['Row']
export type TOTPCategoryInsert = Database['public']['Tables']['totp_categories']['Insert']
export type TOTPCategorySelect = Database['public']['Tables']['totp_categories']['Update']
